import { Component, Vue } from 'vue-property-decorator';
import api from '@/api/api'

import { WeChatUserInfo } from '../WeChatUserInfo';
import UploadFile from '@/shared/services/oss.service';
import { Button, Dialog, Toast } from 'vant';

import AddResumeRecruitInfo from './recruit-info/recruit-info.vue';
import AddResumeBaseInfo from './basic-info/basic-info.vue';
import AddResumeEducationInfo from './education-info/education-info.vue';
import AddResumeEnclosureInfo from './enclosure-info/enclosure-info.vue';
import AddResumeOptionalInfo from './optional-info/optional-info.vue';

@Component({
    components: {
        [Button.name]: Button,
        AddResumeRecruitInfo,
        AddResumeBaseInfo,
        AddResumeEducationInfo,
        AddResumeEnclosureInfo,
        AddResumeOptionalInfo,
    },
})
export default class AddResume extends Vue {
    step: any = null; // 当前步骤
    areaList: any = []; // 省市信息
    user: WeChatUserInfo = new WeChatUserInfo(); // 当前用户信息
    isEdit = false;       // 编辑状态
    inResumeing = false; // 在录用简历中
    resumeId = ''; // 简历id
    isMobil = true; // 是否是移动端
    WeChatloginUrl = '';
    WeChatloginShow = false;
    isDisabled = false; // 按钮置灰
    fileLimit: any = { fileType: '*', fileLength: 1, fileSize: 8 }; // 简历附件限制
    resumeFileURL = '';; // 简历附件url

    dataInfo: any = {}; // 简历信息
    recruitPageInfo: any = {}; // 应聘信息

    created() {
        Toast.loading({
            message: '加载中...',
            forbidClick: true,
            loadingType: 'spinner',
            duration: 0,
        });
        this.startLogin(); // 开始登录
        this.getProvinceInfo(); // 获取省份信息
    }

    // 开始登录
    private startLogin() {
        const redirctUri = location.origin + '?wechatlogin=add-resume'; // 微信登录回调地址
        const APPID = process.env.VUE_APP_WECHATOPEN_RECRUIT_APPID; // 开放平台应用ID
        this.WeChatloginUrl = `https://open.weixin.qq.com/connect/qrconnect?appid=${APPID}&redirect_uri=${encodeURI(redirctUri)}&response_type=code&scope=snsapi_login&state=ehrpclogin#wechat_redirect`;
        console.log(this.WeChatloginUrl);
        // 判断是PC端还是手机端
        function checkMobile() {
            // eslint-disable-next-line @typescript-eslint/camelcase
            const pda_user_agent_list = ['2.0 MMP', '240320', 'AvantGo', 'BlackBerry', 'Blazer',
                'Cellphone', 'Danger', 'DoCoMo', 'Elaine/3.0', 'EudoraWeb', 'hiptop', 'IEMobile', 'KYOCERA/WX310K', 'LG/U990',
                'MIDP-2.0', 'MMEF20', 'MOT-V', 'NetFront', 'Newt', 'Nintendo Wii', 'Nitro', 'Nokia',
                'Opera Mini', 'Opera Mobi', 'Palm', 'Playstation Portable', 'portalmmm', 'Proxinet', 'ProxiNet',
                'SHARP-TQ-GX10', 'Small', 'SonyEricsson', 'Symbian OS', 'SymbianOS', 'TS21i-10', 'UP.Browser', 'UP.Link',
                'Windows CE', 'WinWAP', 'Android', 'iPhone', 'iPod', 'iPad', 'Windows Phone', 'HTC'];
            // eslint-disable-next-line @typescript-eslint/camelcase
            const pda_app_name_list = ['Microsoft Pocket Internet Explorer'];
            // eslint-disable-next-line @typescript-eslint/camelcase
            const user_agent = navigator.userAgent.toString();
            // eslint-disable-next-line @typescript-eslint/camelcase
            for (const a of pda_user_agent_list) {
                // eslint-disable-next-line @typescript-eslint/camelcase
                if (user_agent.indexOf(a) >= 0) {
                    return true;
                }
            }
            const appName = navigator.appName.toString();
            // eslint-disable-next-line @typescript-eslint/camelcase
            for (const b of pda_app_name_list) {
                // eslint-disable-next-line @typescript-eslint/camelcase
                if (user_agent.indexOf(b) >= 0) {
                    return true;
                }
            }
            return false;
        }
        if (checkMobile()) {
            // 移动端
            this.isMobil = true;
            // 使用微信公众平台登录
            this.loginWeChatMobile();
        } else {
            // pc端
            this.isMobil = false;
            // 使用微信开放平台登录
            // this.user.unionid = 'oSlQCt6c3xU1WDvD22bDgTIO_plQ';

            this.loginWeChatPC();
        }

        // 如果没有认证参数，说明是第一次进入页面，不需要去获取数据源，等待微信登录认证后跳转
        if (!location.href.split('?')[1]) {
            return;
        }

        // 检查当前状态是新增还是编辑
        if (this.user.openid) {
            this.getCampResume();
        }
    }

    // 3.4.10 投递简历使用微信登录
    /**
     * @description 微信公众平台登录(移动端)
     * @description 第一次进入页面：查询地址栏参数，没有unionid，发起微信授权认证，认证完成后通过回调第二次进入页面
     * @description 第二次进入页面：查询地址栏参数，存在unionid，则认证成功，并记录unionid
     */
    private loginWeChatMobile() {
        const query = new URLSearchParams(location.href.split('?')[1]);
        this.user.initWithURLSearchParams(query);
        if (this.user.openid && this.user.unionid) {
            console.log(this.user.nickname + ' 已登录');
        } else {
            const uri = location.origin + '?wechatlogin=add-resume';
            location.href = 'http://scrm.lunz.cn/OpenOAuth/getuserinfo?appId=wx70cfc5b45951c5c8&fromurl=' + encodeURI(uri);
        }
    }
    /**
     * @description 微信开放平台登录(PC端)
     * @description 第一次进入页面：查询地址栏参数，没有code，显示登陆二维码，认证完成后通过回调第二次进入页面
     * @description 第二次进入页面：查询地址栏参数，存在code，将code传给后台换取unionid，如果成功则记录unionid，如果不成功则弹出登陆二维码重新认证
     */
    private loginWeChatPC() {
        const query = new URLSearchParams(location.href.split('?')[1]);
        if (query.get('code')) {
            this.user.code = query.get('code');
            this.getUnionidByCode(); // code传给后台换取unionid
        } else {
            this.WeChatloginShow = true;
        }
    }
    /**
     * @description 根据code获取UnionID
     * @description 这里需要后台调用微信开放平台相关接口，将code通过微信接口交换为unionid，并传回前台
     */
    private getUnionidByCode() {
        const entity = {
            appKey: process.env.VUE_APP_EHR_APPKEY,
            code: this.user.code
        }
        api.getRecruitUnionIdByEHR(entity).then((res: any) => {
            if (res.Data) {
                this.user.unionid = res.Data.unionid;
                this.user.openid = res.Data.openid;
                if (this.user.openid) {
                    // 认证通过，根据openid获取用户简历信息
                    this.getCampResume();
                } else {
                    this.needLogin();
                }
            }
        }).catch((error: any) => {
            // 这里除了后台接口出错以外，还有一种原因是code已经被解析过一次
            // code存在于查询参数中，第一次回调进入页面它被正确解析，但用户刷新页面或者故意拼接code参数时也会去后端认证，第二次解析code时已经失效，需要重新扫码
            this.needLogin();
        });
    }

    /** 
     * @description 如果解析失败，跳转回去登录
     */
    private needLogin() {
        // 这里实际上不会发生跳转，因为路由没有发生任何变化，只是把参数清空了, 所以手动把code清空并弹出二维码
        this.$router.push('/add-resume');
        this.user.code = '';
        this.WeChatloginShow = true;
    }

    // 获取省份信息
    getProvinceInfo() {
        api.getProvinceInfo().then((res: any) => {
            this.areaList = res.districtDetails || [];
            this.step = 1;
            Toast.clear();
        }).catch((error: any) => {
            Toast.clear();
            Dialog.alert({
                title: '提示',
                message: '数据获取失败：' + error,
            });
        });
    }

    // 接收子组件信息
    getRecruitInfo(data: any) {
        if (data.currentStep && data.move) {
            if (!(data.move === 'next' && data.currentStep === 5)) {
                this.step = (data.move === 'next' ? (data.currentStep + 1) : (data.currentStep - 1));
            }
        }
        if (data.fromInfo && data.currentStep) {
            if (data.currentStep === 1) {
                this.recruitPageInfo = data.fromInfo; // 应聘信息
                this.dataInfo = Object.assign(this.recruitPageInfo, this.dataInfo);
            } else if (data.currentStep === 2) {
                const baseInfo = data.fromInfo; // 基本信息
                this.dataInfo = Object.assign(baseInfo, this.dataInfo);
            } else if (data.currentStep === 3) {
                const educationInfo = data.fromInfo; // 学历信息
                this.dataInfo.educates = educationInfo;
            } else if (data.currentStep === 4) {
                const enclosureInfo = data.fromInfo; // 附件信息
                this.dataInfo.files = enclosureInfo;
            } else if (data.currentStep === 5) {
                const optionalInfo = data.fromInfo; // 选填信息
                this.dataInfo = Object.assign(optionalInfo, this.dataInfo);
                // 提交
                this.submitResume();
            }
        }
        if (data.currentStep === 1 && data.resumeFileURL) {
            this.analysisResumeInfo(data.resumeFileURL);
        }
    }

    // 解析简历
    analysisResumeInfo(resumeUrl: any) {
        const entity = {
            url: resumeUrl,
        }
        api.analyzeSchoolResume(entity).then((res: any) => {
            this.dataInfo = res;
            this.dataInfo = Object.assign(this.dataInfo, this.recruitPageInfo);
            this.$message({
                message: '简历解析成功',
                type: 'success'
            });
        }).catch((error: any) => {
            Dialog.alert({
                title: '提示',
                message: '简历解析失败：' + error + '，请重试',
            });
        });
    }

    // 上传简历附件
    uploadResumeFile(file: any) {
        const fileSize = this.fileLimit.fileSize * 1024;
        if ((file.file.size / 1024) > fileSize) {
            this.$message({
                message: '附件最大为' + this.fileLimit.fileSize + 'M',
                type: 'warning'
            });
            return false;
        }
        UploadFile.addFileAliyun(file.file).then(
            (res: any) => {
                this.resumeFileURL = res.url;
                this.analysisResumeInfo(this.resumeFileURL);
            }
        )
        return false;
    }

    // 编辑获取简历信息
    getCampResume() {
        // 编辑时
        const entity = {
            openId: this.user.openid,
        }
        api.getSchoolResume(entity).then((res: any) => {
            this.dataInfo = res;
        }).catch((error: any) => {
            Dialog.alert({
                title: '提示',
                message: '简历信息获取失败：' + error,
            });
        });
    }

    // 提交简历
    submitResume() {
        this.dataInfo.openId = this.user.openid;
        api.submitSchoolResume(this.dataInfo).then((res: any) => {
            if (res) {
                this.step = 6;
            }
        }).catch((error: any) => {
            Dialog.alert({
                title: '提示',
                message: '提交失败：' + error,
            });
            const optionalInfoComponent = (this as any).$children.find((m: { $options: { _componentTag: string } }) => m.$options._componentTag === "AddResumeOptionalInfo");
            optionalInfoComponent.isLoading = false;
        });
    }
}
